import { useHistory } from "react-router-dom";
import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import {NavbarLoginWidget, useBreakpoint} from "@brg/ui";
import { CreateLinkTo, LinkTo } from "shared/constants/linkTo";
import styled, { useTheme, css } from "styled-components";
import { useAuth } from "core/hooks/auth/useAuth";
import { AppTester } from "supporting";
import { ProfileUtils } from "@brg/auth";
import { AVATAR_SIZES, FIXED_AVATAR_SIZE, getAvatarSizes } from "shared/constants/AvatarSizes";
import LogoutIcon from "shared/icons/LoginWidgetIcons/LogoutIcon";
import SupportIcon from "shared/icons/LoginWidgetIcons/SupportIcon";
import CalendarsIcon from "shared/icons/LoginWidgetIcons/CalendarsIcon";
import BooksIcon from "shared/icons/LoginWidgetIcons/BooksIcon";
import CoursesIcon from "shared/icons/LoginWidgetIcons/CoursesIcon";
import ShopIcon from "shared/icons/LoginWidgetIcons/ShopIcon";
import PurchasesIcon from "shared/icons/LoginWidgetIcons/PurchasesIcon";
import GiftsIcon from "shared/icons/LoginWidgetIcons/GiftsIcon";
import WalletIcon from "shared/icons/LoginWidgetIcons/WalletIcon";
import SettingsIcon from "shared/icons/LoginWidgetIcons/SettingsIcon";
import ProfileIcon from "shared/icons/LoginWidgetIcons/ProfileIcon";
import { useGetSellers } from "shared/hooks/api/useGetSellers";

const NavbarLoginWrapper = styled.div<{isGeo?: boolean, isKiiidsArt?: boolean}>`

  .dropdown-element-popup {
    height: calc(100vh - 177px);
    &, & div {
      ::-webkit-scrollbar-track {
        background: #E7E7E7 !important;
        width: 4px !important;
      }
      ::-webkit-scrollbar-thumb {
        background: #B6B6B5 !important;
        border-radius: 2px !important;
        width: 4px !important;
      }
      ::-webkit-scrollbar {
        width: 4px !important;
      }
    } 
  }

  @media(max-width: 743px) {
    .dropdown-element-popup {
      height: calc(100vh - 28px);
    }
  }

  svg {
    width: 16px;
    height: 16px;
  } 
  ${({isKiiidsArt}) => isKiiidsArt && css`
    .dropdown-button > div {
      border-radius: 8px;
    }
  `}
    ${({isGeo}) => isGeo && css`
      .dropdown-list-item {
        color: #8E9193;
        background: #3F4548 !important;
        
        &:hover {
          background: #575B5E !important
        }
      }`
    }

`;
const WidgetLogin : FC<{personalCollection?: any}> = (props: any) => {
  //const { emit, associatedProfile, token } = useAuth();
  const auth = useAuth();
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const theme = useTheme();
  const isEducation = AppTester.isGeoDafes();
  const isGeo = AppTester.isGeograffee()
  const isGeoMain = AppTester.isGeoMain()
  const isMediiia = AppTester.isMediiia()
  const isHseSpace = AppTester.isHseSpace()
  const isDeziiignMain = AppTester.isDeziiignMain()
  const isGallllery = AppTester.isGallllery()
  const isKiiidsArt = AppTester.isKiiidsArt()
  const isHseColors = AppTester.isHseColors();
  const isCGRAVE = AppTester.isCGRAVE();
  const isGreenAward = AppTester.isGreenAward();
  const isSuperPuper = AppTester.isSuperPuper();
  const isContinuumSite = AppTester.isContinuumSite();
  const isGameDeziiign = AppTester.isGameDeziiign();

  const isMobile = useBreakpoint(743)

  const isAcademy = AppTester.isAcademy();

  const profile = auth.token ? auth.associatedProfile : undefined;

  const shops = useGetSellers(profile)

  const dropdownGreenAward = useMemo(() => {
    const items = [];

    if (profile) {
      items.push({
        title: t('nav.profile.profile'),
        action: () => history.push(CreateLinkTo.designerNew(profile)),
      });
      // пункт НАСТРОЙКИ ПРОФИЛЯ
      items.push({
        title: t('designer_edit.sections.settings'),
        action: () => history.push(CreateLinkTo.designerEdit(profile.designerId)),
      });
    }

    items.push({
      title: t('nav.profile.logout'),
      action: () => auth.logout(),
    });

    return items;
  }, [profile, t, history, auth]);

  const dropdownFull = useMemo(() => {
    const items: Array<{ title: string; action: () => void, icon?: any, isDivider?: boolean }> = [];
  
    // Пункт «Профиль»
    if (profile) {
      items.push({
        title: t('nav.profile.profile'),
        action: () => {
          if (isKiiidsArt) {
            window.open(
              `${process.env.REACT_APP_URL_KIIIDS_ART}/collection/${profile.designerId}`,
              '_blank'
            )
          } else {
            history.push(CreateLinkTo.designerNew(profile))
          }
        },
        icon: <ProfileIcon />
      });
      // пункт НАСТРОЙКИ ПРОФИЛЯ
      items.push({
        title: t('designer_edit.sections.settings'),
        action: () => history.push(CreateLinkTo.designerEdit(profile.designerId)),
        icon: <SettingsIcon />
      });
    };
  
    // Пункт «Кошелёк»
    items.push({
      title: t('nav.wallet'),
      action: () =>
        window.open(`${process.env.REACT_APP_URL_ACCOUNT}/wallet`, '_blank'),
      icon: <WalletIcon />
    });

    // Пункт «Подарки»
    items.push({
      title: t('nav.profile.gifts'),
      action: () =>
        window.open(`${process.env.REACT_APP_URL_ACCOUNT}/gifts`, '_blank'),
      icon: <GiftsIcon />
    });

    // Пункт «Покупки»
    items.push({
      title: t('nav.profile.purchases'),
      action: () =>
        window.open(`${process.env.REACT_APP_URL_ACCOUNT}/purchases`, '_blank'),
      icon: <PurchasesIcon />
    });
    

    // Пункт «Магазины»
    if (shops?.length) {
        items.push({
        title: t('nav.profile.business'),
        action: () =>
          window.open(`${process.env.REACT_APP_URL_ACCOUNT}/business`, '_blank'),
        icon: <ShopIcon />
      })
    };

    items.push({
        title: 'divider1',
        action: () => false,
        isDivider: true
      })
  
    // Профиль на Mediiia
    if (!isMediiia && profile) {
      items.push({
        title: t('nav.profile.profileMediiia'),
        action: () =>
          window.open(
            `${process.env.REACT_APP_URL_MEDIIIA_COM}/designer/${profile.designerId}`,
            '_blank'
          ),
      });
    }
  
    // Профиль на HSE Space
    if (!isHseSpace && profile) {
      items.push({
        title: t('nav.profile.profileHseSpace'),
        action: () =>
          window.open(
            `${process.env.REACT_APP_URL_HSE_SPACE}/designer/${profile.designerId}`,
            '_blank'
          ),
      });
    }
  
    // Профиль на My Deziiign
    if (!isDeziiignMain && profile) {
      items.push({
        title: t('nav.profile.profileMyDeziiign'),
        action: () =>
          window.open(
            `${process.env.REACT_APP_URL_DEZIIIGN_RU}/designer/${profile.designerId}`,
            '_blank'
          ),
      });
    };
  
    // Профиль на My Gallllery
    if (!isGallllery && profile) {
      items.push({
        title: t('nav.profile.profileMyGallllery'),
        action: () =>
          window.open(
            `${process.env.REACT_APP_GALLERY_LINK}/collection/${profile.designerId}`,
            '_blank'
          ),
      });
    };
  
    // Профиль на Artz Work
    if (profile) {
      items.push({
        title: t('nav.profile.profileMyArtzWork'),
        action: () =>
          window.open(
            `${process.env.REACT_APP_URL_ARTZ}/profile/museum/${profile.designerId}`,
            '_blank'
          ),
      });
    };
  
    // Профиль на Kiiids Art
    if (!isKiiidsArt && profile) {
      items.push({
        title: t('nav.profile.profileMyKiiidsArt'),
        action: () =>
          window.open(
            `${process.env.REACT_APP_URL_KIIIDS_ART}/collection/${profile.designerId}`,
            '_blank'
          ),
      });
    };

    items.push({
        title: 'divider2',
        action: () => false,
        isDivider: true
    });
  
    // Мои курсы
    items.push({
      title: t('nav.my_courses'),
      action: () =>
        window.open(
          `${process.env.REACT_APP_URL_HSEDESIGN_LMS}${LinkTo.myCourses}`,
          '_blank'
        ),
      icon: <CoursesIcon />
    });
  
    // Мои книги
    items.push({
      title: t('nav.my_books'),
      action: () =>
        window.open(
          `${process.env.REACT_APP_URL_BOOKS_GALLLLERY_RU}${LinkTo.myBooks}`,
          '_blank'
        ),
        icon: <BooksIcon />
    });
  
    // Мои календари
    items.push({
      title: t('payment.my_calendars'),
      action: () =>
        window.open(
          `${process.env.REACT_APP_GALLERY_LINK}/365/mycalendars?shouldForcedLogin=true&saveLoginUrl=true`,
          '_blank'
        ),
      icon: <CalendarsIcon />
    });

    items.push({
        title: 'divider3',
        action: () => false,
        isDivider: true
    });

    // items.push({
    //     title: 'nav.profile.profile.support',
    //     action: () => false,
    //     icon: <SupportIcon />
    // });
  
    // Пункт «Выйти»
    items.push({
      title: t('nav.profile.logout'),
      action: () => auth.logout(),
      icon: <LogoutIcon />
    });
  
    return items;
  }, [
    profile,
    auth,
    isMediiia,
    isHseSpace,
    isDeziiignMain,
    isGallllery,
    isKiiidsArt
  ]);

  if (isHseColors) return null;

  return (
    <NavbarLoginWrapper isKiiidsArt={isKiiidsArt} isGeo={isGeoMain || isAcademy || isGameDeziiign}>
      <NavbarLoginWidget
          theming={theme.navigationBar.login}
          user={
            profile
                ? {
                  letters: ProfileUtils.getLetters(profile),
        // @ts-ignore
                  avatarUrl: ProfileUtils.getAvatarURLOrUndefined(profile, getAvatarSizes(AVATAR_SIZES.smallProfile), FIXED_AVATAR_SIZE),
                  name: ProfileUtils.getFullNameString(profile)
                }
                : undefined
          }
          loginButtonText={t("nav.login") ?? ""}
          loginAction={() => auth.login()}
          logoutAction={() => auth.logout()}
          dark={isGeo && !isEducation || isCGRAVE || isContinuumSite || isSuperPuper}
          dropdown={isGreenAward ? dropdownGreenAward : dropdownFull}
          isMobile={isMobile}
          dropdownPopupTop={isMobile? -8 : undefined}
          dropdownPopupRight={isMobile? -10 : undefined}
      />
      </NavbarLoginWrapper>
  );
};

export default WidgetLogin;
import { useHistory } from "react-router-dom";
import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import {NavbarLoginWidget, useBreakpoint} from "@brg/ui";
import { CreateLinkTo, LinkTo } from "shared/constants/linkTo";
import styled, { useTheme, css } from "styled-components";
import { useAuth } from "core/hooks/auth/useAuth";
import { AppTester } from "supporting";
import { ProfileUtils } from "@brg/auth";
import { AVATAR_SIZES, FIXED_AVATAR_SIZE, getAvatarSizes } from "shared/constants/AvatarSizes";
import LogoutIcon from "shared/icons/LoginWidgetIcons/LogoutIcon";
import SupportIcon from "shared/icons/LoginWidgetIcons/SupportIcon";
import CalendarsIcon from "shared/icons/LoginWidgetIcons/CalendarsIcon";
import BooksIcon from "shared/icons/LoginWidgetIcons/BooksIcon";
import CoursesIcon from "shared/icons/LoginWidgetIcons/CoursesIcon";
import ShopIcon from "shared/icons/LoginWidgetIcons/ShopIcon";
import PurchasesIcon from "shared/icons/LoginWidgetIcons/PurchasesIcon";
import GiftsIcon from "shared/icons/LoginWidgetIcons/GiftsIcon";
import WalletIcon from "shared/icons/LoginWidgetIcons/WalletIcon";
import SettingsIcon from "shared/icons/LoginWidgetIcons/SettingsIcon";
import ProfileIcon from "shared/icons/LoginWidgetIcons/ProfileIcon";
import { useGetSellers } from "shared/hooks/api/useGetSellers";

const NavbarLoginWrapper = styled.div<{isGeo?: boolean, isKiiidsArt?: boolean}>`

  .dropdown-element-popup {
    height: calc(100vh - 177px);
    &, & div {
      ::-webkit-scrollbar-track {
        background: #E7E7E7 !important;
        width: 4px !important;
      }
      ::-webkit-scrollbar-thumb {
        background: #B6B6B5 !important;
        border-radius: 2px !important;
        width: 4px !important;
      }
      ::-webkit-scrollbar {
        width: 4px !important;
      }
    } 
  }

  @media(max-width: 743px) {
    .dropdown-element-popup {
      height: calc(100vh - 28px);
    }
  }

  svg {
    width: 16px;
    height: 16px;
  } 
  ${({isKiiidsArt}) => isKiiidsArt && css`
    .dropdown-button > div {
      border-radius: 8px;
    }
  `}
    ${({isGeo}) => isGeo && css`
      .dropdown-list-item {
        color: #8E9193;
        background: #3F4548 !important;
        
        &:hover {
          background: #575B5E !important
        }
      }`
    }

`;
const WidgetLogin : FC<{personalCollection?: any}> = (props: any) => {
  //const { emit, associatedProfile, token } = useAuth();
  const auth = useAuth();
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const theme = useTheme();
  const isEducation = AppTester.isGeoDafes();
  const isGeo = AppTester.isGeograffee()
  const isGeoMain = AppTester.isGeoMain()
  const isMediiia = AppTester.isMediiia()
  const isHseSpace = AppTester.isHseSpace()
  const isDeziiignMain = AppTester.isDeziiignMain()
  const isGallllery = AppTester.isGallllery()
  const isKiiidsArt = AppTester.isKiiidsArt()
  const isHseColors = AppTester.isHseColors();
  const isCGRAVE = AppTester.isCGRAVE();
  const isGreenAward = AppTester.isGreenAward();
  const isSuperPuper = AppTester.isSuperPuper();
  const isContinuumSite = AppTester.isContinuumSite();
  const isGameDeziiign = AppTester.isGameDeziiign();

  const isMobile = useBreakpoint(743)

  const isAcademy = AppTester.isAcademy();

  const profile = auth.token ? auth.associatedProfile : undefined;

  const shops = useGetSellers(profile)

  const dropdownGreenAward = useMemo(() => {
    const items = [];

    if (profile) {
      items.push({
        title: t('nav.profile.profile'),
        action: () => history.push(CreateLinkTo.designerNew(profile)),
      });
      // пункт НАСТРОЙКИ ПРОФИЛЯ
      items.push({
        title: t('designer_edit.sections.settings'),
        action: () => history.push(CreateLinkTo.designerEdit(profile.designerId)),
      });
    }

    items.push({
      title: t('nav.profile.logout'),
      action: () => auth.logout(),
    });

    return items;
  }, [profile, t, history, auth]);

  const dropdownFull = useMemo(() => {
    const items: Array<{ title: string; action: () => void, icon?: any, isDivider?: boolean }> = [];
  
    // Пункт «Профиль»
    if (profile) {
      items.push({
        title: t('nav.profile.profile'),
        action: () => {
          if (isKiiidsArt) {
            window.open(
              `${process.env.REACT_APP_URL_KIIIDS_ART}/collection/${profile.designerId}`,
              '_blank'
            )
          } else {
            history.push(CreateLinkTo.designerNew(profile))
          }
        },
        icon: <ProfileIcon />
      });
      // пункт НАСТРОЙКИ ПРОФИЛЯ
      items.push({
        title: t('designer_edit.sections.settings'),
        action: () => history.push(CreateLinkTo.designerEdit(profile.designerId)),
        icon: <SettingsIcon />
      });
    };
  
    // Пункт «Кошелёк»
    items.push({
      title: t('nav.wallet'),
      action: () =>
        window.open(`${process.env.REACT_APP_URL_ACCOUNT}/wallet`, '_blank'),
      icon: <WalletIcon />
    });

    // Пункт «Подарки»
    items.push({
      title: t('nav.profile.gifts'),
      action: () =>
        window.open(`${process.env.REACT_APP_URL_ACCOUNT}/gifts`, '_blank'),
      icon: <GiftsIcon />
    });

    // Пункт «Покупки»
    items.push({
      title: t('nav.profile.purchases'),
      action: () =>
        window.open(`${process.env.REACT_APP_URL_ACCOUNT}/purchases`, '_blank'),
      icon: <PurchasesIcon />
    });
    

    // Пункт «Магазины»
    if (shops?.length) {
        items.push({
        title: t('nav.profile.business'),
        action: () =>
          window.open(`${process.env.REACT_APP_URL_ACCOUNT}/business`, '_blank'),
        icon: <ShopIcon />
      })
    };

    items.push({
        title: 'divider1',
        action: () => false,
        isDivider: true
      })
  
    // Профиль на Mediiia
    if (!isMediiia && profile) {
      items.push({
        title: t('nav.profile.profileMediiia'),
        action: () =>
          window.open(
            `${process.env.REACT_APP_URL_MEDIIIA_COM}/designer/${profile.designerId}`,
            '_blank'
          ),
      });
    }
  
    // Профиль на HSE Space
    if (!isHseSpace && profile) {
      items.push({
        title: t('nav.profile.profileHseSpace'),
        action: () =>
          window.open(
            `${process.env.REACT_APP_URL_HSE_SPACE}/designer/${profile.designerId}`,
            '_blank'
          ),
      });
    }
  
    // Профиль на My Deziiign
    if (!isDeziiignMain && profile) {
      items.push({
        title: t('nav.profile.profileMyDeziiign'),
        action: () =>
          window.open(
            `${process.env.REACT_APP_URL_DEZIIIGN_RU}/designer/${profile.designerId}`,
            '_blank'
          ),
      });
    };
  
    // Профиль на My Gallllery
    if (!isGallllery && profile) {
      items.push({
        title: t('nav.profile.profileMyGallllery'),
        action: () =>
          window.open(
            `${process.env.REACT_APP_GALLERY_LINK}/collection/${profile.designerId}`,
            '_blank'
          ),
      });
    };
  
    // Профиль на Artz Work
    if (profile) {
      items.push({
        title: t('nav.profile.profileMyArtzWork'),
        action: () =>
          window.open(
            `${process.env.REACT_APP_URL_ARTZ}/profile/museum/${profile.designerId}`,
            '_blank'
          ),
      });
    };
  
    // Профиль на Kiiids Art
    if (!isKiiidsArt && profile) {
      items.push({
        title: t('nav.profile.profileMyKiiidsArt'),
        action: () =>
          window.open(
            `${process.env.REACT_APP_URL_KIIIDS_ART}/collection/${profile.designerId}`,
            '_blank'
          ),
      });
    };

    items.push({
        title: 'divider2',
        action: () => false,
        isDivider: true
    });
  
    // Мои курсы
    items.push({
      title: t('nav.my_courses'),
      action: () =>
        window.open(
          `${process.env.REACT_APP_URL_HSEDESIGN_LMS}${LinkTo.myCourses}`,
          '_blank'
        ),
      icon: <CoursesIcon />
    });
  
    // Мои книги
    items.push({
      title: t('nav.my_books'),
      action: () =>
        window.open(
          `${process.env.REACT_APP_URL_BOOKS_GALLLLERY_RU}${LinkTo.myBooks}`,
          '_blank'
        ),
        icon: <BooksIcon />
    });
  
    // Мои календари
    items.push({
      title: t('payment.my_calendars'),
      action: () =>
        window.open(
          `${process.env.REACT_APP_GALLERY_LINK}/365/mycalendars?shouldForcedLogin=true&saveLoginUrl=true`,
          '_blank'
        ),
      icon: <CalendarsIcon />
    });

    items.push({
        title: 'divider3',
        action: () => false,
        isDivider: true
    });

    // items.push({
    //     title: 'nav.profile.profile.support',
    //     action: () => false,
    //     icon: <SupportIcon />
    // });
  
    // Пункт «Выйти»
    items.push({
      title: t('nav.profile.logout'),
      action: () => auth.logout(),
      icon: <LogoutIcon />
    });
  
    return items;
  }, [
    profile,
    auth,
    isMediiia,
    isHseSpace,
    isDeziiignMain,
    isGallllery,
    isKiiidsArt
  ]);

  if (isHseColors) return null;

  return (
    <NavbarLoginWrapper isKiiidsArt={isKiiidsArt} isGeo={isGeoMain || isAcademy || isGameDeziiign}>
      <NavbarLoginWidget
          theming={theme.navigationBar.login}
          user={
            profile
                ? {
                  letters: ProfileUtils.getLetters(profile),
        // @ts-ignore
                  avatarUrl: ProfileUtils.getAvatarURLOrUndefined(profile, getAvatarSizes(AVATAR_SIZES.smallProfile), FIXED_AVATAR_SIZE),
                  name: ProfileUtils.getFullNameString(profile)
                }
                : undefined
          }
          loginButtonText={t("nav.login") ?? ""}
          loginAction={() => auth.login()}
          logoutAction={() => auth.logout()}
          dark={isGeo && !isEducation || isCGRAVE || isContinuumSite || isSuperPuper}
          dropdown={isGreenAward ? dropdownGreenAward : dropdownFull}
          isMobile={isMobile}
          dropdownPopupTop={isMobile? -8 : undefined}
          dropdownPopupRight={isMobile? -10 : undefined}
      />
      </NavbarLoginWrapper>
  );
};

export default WidgetLogin;
